// Central content + curated imagery for PMN
export const IMG = {
  heroCity:
    "https://images.unsplash.com/photo-1724966974920-f390f30ad6f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  heroBoardroom:
    "https://images.unsplash.com/photo-1571624436279-b272aff752b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  boardroomWarm:
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  boardroomTable:
    "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  meetingLead:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  meetingTeam:
    "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  meetingCandid:
    "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  collaborate:
    "https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  whiteboard:
    "https://images.unsplash.com/photo-1677506050775-18ac86b9c2c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  glassTowers:
    "https://images.unsplash.com/photo-1512403754473-27835f7b9984?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  glassDusk:
    "https://images.unsplash.com/photo-1470075801209-17f9ec0cada6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  glassEye:
    "https://images.unsplash.com/photo-1435575653489-b0873ec954e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  fintech:
    "https://images.unsplash.com/photo-1702047063975-0841a0621b5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  healthcare:
    "https://images.unsplash.com/photo-1512102438733-bfa4ed29aef7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dataServer:
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dataBlue:
    "https://images.unsplash.com/photo-1561233835-f937539b95b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aiAbstract:
    "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aiCircuit:
    "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lounge:
    "https://images.unsplash.com/photo-1780307205444-a8693eef2f4a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  loungeWood:
    "https://images.unsplash.com/photo-1758448093806-88b2089068ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  founder:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_senior-bench/artifacts/cmwwih7d_Brandon%20Rodgers%20-%20Headshot%20-%20Park%20Suit.jpeg",
  defenseAero:
    "https://images.unsplash.com/photo-1775795743974-3c833ecee140?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  telecom:
    "https://images.unsplash.com/photo-1758982679277-1e9f98ad4afa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const INDUSTRIES = [
  { id: "financial-services", name: "Financial Services & Banking", img: IMG.glassTowers, note: "Regional banks, bank holding companies, and lending — where audit trails, controls, and cross-LOB alignment are non-negotiable." },
  { id: "fintech", name: "Fintech & Financial Software", img: IMG.fintech, note: "Platform launches, migrations, and scaling operations for fintech and financial-software firms — at pace, with rigor." },
  { id: "healthcare", name: "Healthcare & Healthcare Technology", img: IMG.healthcare, note: "EHR rollouts, clinical operations, and payer-provider initiatives. Multi-stakeholder and patient-safety critical." },
  { id: "defense", name: "Defense & Regulated Industries", img: IMG.defenseAero, note: "Prime-contractor and regulated-industry programs aligned to CMMC, NIST SP 800-171, and secure delivery standards." },
];

export const CREDENTIALS = ["PMP", "PMI-ACP", "CSM", "M.S. — NYU"];

export const PROCESS = [
  { n: "01", title: "Diagnose", body: "We listen — to the people doing the work, the executives funding it, and the data. By the end you have a clear picture of where things stand." },
  { n: "02", title: "Align", body: "We get decision-makers in the same room, put disagreements on the table, and produce a shared definition of success." },
  { n: "03", title: "Structure", body: "We build the operating model — governance, cadence, reporting, and tooling — so the program runs on a clear rhythm of accountability." },
  { n: "04", title: "Execute", body: "We embed and run the work, holding the line on cadence and decisions. Every week the program moves forward, and the data shows it." },
  { n: "05", title: "Transition", body: "We document everything, train your people, and exit cleanly — leaving a program that runs without us." },
];

export const CASE_STUDIES = [
  {
    sector: "Financial Services",
    title: "Enterprise transformation across 8 functions at a top-tier global bank",
    metrics: [["$12M", "annual savings"], ["98%", "on-time"], ["50+", "team members"]],
  },
  {
    sector: "Defense & Regulated Industries",
    title: "Trilateral secure co-development program (U.S. · U.K. · Australia)",
    metrics: [["3", "jurisdictions"], ["CMMC", "L1/L2 aligned"], ["Enclave", "architecture"]],
  },
  {
    sector: "Healthcare",
    title: "$25M+ digital transformation for a major pediatric health system",
    metrics: [["26", "system rollouts"], ["65+", "team members"], ["25%", "fewer defects"]],
  },
  {
    sector: "Fintech & Financial Software",
    title: "Process automation program across 55+ critical workflows",
    metrics: [["$8M+", "annualized savings"], ["25%", "faster cycles"], ["55+", "workflows"]],
  },
];

export const CASE_STUDIES_DETAIL = [
  {
    id: "financial-services",
    name: "Financial Services & Banking",
    img: IMG.glassTowers,
    tagline: "Regional Banks · Bank Holding Companies · Lending",
    intro:
      "Financial programs don't just need to ship — they need to ship with audit trails, compliance evidence, and stakeholder buy-in across risk, legal, technology, and operations. Most program failures come from underestimating the governance burden, not the technical work.",
    problems: [
      "Programs miss regulator deadlines because internal alignment took longer than expected.",
      "Risk, compliance, and technology teams operate from different versions of the truth.",
      "Status reports look green right up until the program misses a milestone.",
      "Cross-LOB initiatives stall on decision rights and competing priorities.",
    ],
    leads: [
      "Enterprise digital transformation programs",
      "Risk, data, and controls program leadership",
      "Regulatory delivery — compliance, controls, audit remediation",
      "PMO stand-up and governance redesign",
      "Vendor selection, RFP, and SaaS platform integration",
    ],
    study: {
      title: "Global enterprise transformation across 8 business functions at a top-tier global bank",
      challenge:
        "A top-tier global bank running 13+ cross-functional groups had multiple in-flight initiatives with no consistent governance, standardized reporting, or clear executive decision rights. Leadership could see activity, but not outcomes — and the gap between strategy and execution was widening.",
      approach: [
        "Stepped in as SVP leading global program management, partnering directly with the CIO and C-suite.",
        "Architected multi-year digital strategies worth $25M+ and prioritized technology investment.",
        "Established unified governance across all major business units and 13 organizational PMOs.",
        "Orchestrated programs across 8 business functions and 50+ contributors.",
        "Served as Chief of Staff to senior leadership through peak transformation cycles.",
      ],
      outcome:
        "Realized 10% projected operational savings — $12M annually — at a 98% on-time delivery rate. Reduced operational complexity by 30%, lifted reporting accuracy by 15%, and improved execution efficiency by 22% through standardized methodology, leaving behind a governance model the organization still operates.",
      metrics: [["$12M", "annual savings"], ["98%", "on-time"], ["50+", "contributors"], ["30%", "less complexity"]],
    },
  },
  {
    id: "healthcare",
    name: "Healthcare & Healthcare Technology",
    img: IMG.healthcare,
    tagline: "Health Systems · Clinical Ops · Payer-Provider · HealthTech",
    intro:
      "Healthcare programs touch patients, providers, payers, and regulators all at once. The programs that succeed treat coordination as the actual work — not as overhead. Every meaningful initiative touches clinical operations, IT, finance, compliance, and patient-facing teams simultaneously.",
    problems: [
      "Clinical leadership and IT speak different languages and meet too rarely.",
      "EHR rollouts slip because change management is treated as an afterthought.",
      "Cross-site implementations vary in quality based on local leadership availability.",
      "Reporting structures don't reach the executives who can unblock decisions.",
    ],
    leads: [
      "Enterprise digital transformation programs",
      "Multi-site clinical hardware and software rollouts",
      "System implementation programs",
      "Agile transformation and delivery cadence",
      "Vendor management and SaaS platform integration",
    ],
    study: {
      title: "$25M+ digital transformation program for a major pediatric health system",
      challenge:
        "A major children's healthcare system needed senior leadership for a $25M+ portfolio spanning clinical operations, IT, and patient-facing systems — with cross-functional coordination and on-time delivery both at risk. Clinical, IT, and operations teams historically operated with different priorities and pace.",
      approach: [
        "Led 65+ cross-functional team members through 26 major system implementations.",
        "Built the operating model aligning clinical, IT, and operations on one delivery roadmap.",
        "Instituted Agile delivery practices across the program portfolio.",
        "Redesigned reporting cadence for shared clinical + operational visibility.",
        "Managed dependencies across 26 parallel implementations without disrupting care.",
      ],
      outcome:
        "Achieved 97% on-time execution, accelerated delivery timelines by 15% through Agile adoption, and reduced defect rates by 25% via a structured quality cadence — delivering all 26 implementations within the engagement window while sustaining clinical operations throughout.",
      metrics: [["$25M+", "portfolio"], ["26", "rollouts"], ["65+", "team members"], ["25%", "fewer defects"]],
    },
  },
  {
    id: "defense",
    name: "Defense & Regulated Industries",
    img: IMG.defenseAero,
    tagline: "Prime Contractors · CMMC / NIST · Secure Programs",
    intro:
      "Defense and aerospace programs run on different rules — compliance, classification, and cross-border governance change everything about how delivery works. Programs operating in CMMC, NIST, DISP, and CE/CE+ environments demand a level of traceability most program leaders aren't built to handle.",
    problems: [
      "Cross-border programs stall on classification, clearance, and data residency.",
      "Compliance frameworks (CMMC L1/L2, NIST SP 800-171) are treated as IT-only.",
      "Vendor and tooling decisions don't account for security boundaries.",
      "Multi-country governance becomes a coordination burden no one owns.",
    ],
    leads: [
      "Trilateral secure co-development programs",
      "Enclave architecture and cross-border collaboration alignment",
      "CMMC L1/L2, NIST SP 800-171, DISP, DCC, CE/CE+ governance",
      "Enterprise CRM replacement and workflow automation",
      "Secure remote access standards and multi-country governance",
    ],
    study: {
      title: "Trilateral secure co-development program across the U.S., U.K., and Australia",
      challenge:
        "A top-five U.S. aerospace and defense prime needed IT program leadership for a trilateral secure co-development effort spanning three jurisdictions. It required enclave architecture and simultaneous alignment to CMMC L1/L2, NIST SP 800-171, DISP, DCC, and CE/CE+ — with multi-country governance no one fully owned.",
      approach: [
        "Took IT program leadership, architecting enclave environments across jurisdictions.",
        "Aligned cross-border collaboration to all applicable compliance frameworks.",
        "Led cross-functional teams across security, IT, infrastructure, engineering, BD, and compliance.",
        "Oversaw enterprise tooling, secure remote access standards, and multi-country governance.",
        "Ran parallel CRM replacement and automation of financial, contracting, and ordering workflows.",
      ],
      outcome:
        "Delivered a working multi-country governance framework, integrated enterprise tooling, and secure remote access standards — enabling the program to operate across U.S., U.K., and Australian jurisdictions without compliance friction or operational gaps.",
      metrics: [["3", "jurisdictions"], ["5+", "compliance regimes"], ["3+", "enterprise systems"]],
    },
  },
  {
    id: "fintech",
    name: "Fintech & Financial Software",
    img: IMG.fintech,
    tagline: "Platforms · Payments · Financial Software",
    intro:
      "Fintech and financial-software firms move fast — but the moment they touch regulated money movement, informal coordination stops scaling. PMN brings program rigor that keeps launches and migrations on pace without losing the controls that regulators, partners, and sponsor banks expect.",
    problems: [
      "Cross-functional initiatives lack a single owner with authority to drive decisions.",
      "Platform migrations underestimate dependencies across products and integrations.",
      "Scaling teams don't have intake, prioritization, or resourcing frameworks.",
      "Compliance and controls get bolted on late instead of designed in.",
    ],
    leads: [
      "Platform launches, migrations, and integrations",
      "Payments and money-movement program delivery",
      "GenAI and AI program leadership",
      "Process automation programs",
      "Data governance and enterprise architecture leadership",
    ],
    study: {
      title: "Process automation program across 55+ critical workflows",
      challenge:
        "An enterprise client needed to scale operational efficiency across 55+ business-critical workflows spanning multiple systems and business units. Manual processes were compounding cost, delay, and inconsistency as the organization scaled. The challenge wasn't picking tools — it was building a program to prioritize, execute, and govern automation continuously.",
      approach: [
        "Led the end-to-end automation program from analysis through rollout and governance.",
        "Ran workflow analysis and prioritization across 55+ candidate processes.",
        "Selected vendors and technology aligned to enterprise architecture.",
        "Designed integrations across multiple legacy and SaaS platforms.",
        "Built the operating model to govern automation as an ongoing capability.",
      ],
      outcome:
        "Delivered $8M+ in annualized cost savings (per-workflow savings of 3–15%) and reduced critical cycle times by up to 25% — with sustained governance creating a repeatable model for automation prioritization and delivery across the enterprise.",
      metrics: [["$8M+", "annualized savings"], ["55+", "workflows"], ["25%", "faster cycles"], ["3–15%", "per workflow"]],
    },
  },
];
